'use strict';

import MasterData from './masterData/MasterData.service'
import Grades from './masterData/Grades.service'

const state = {}

const actions = {
  ...MasterData.actions,
  ...Grades.actions,
}

const mutations = {}

const getters = {}

export default { getters, actions, mutations, state }